export const TYPES = Object.freeze({
  SUBMIT: 'submit',
  RESET: 'reset',
  BUTTON: 'button',
})
